import { createMakeStyles } from "tss-react";
import { useTheme } from "@mui/material";

const { makeStyles: tssMakeStyles } = createMakeStyles({ useTheme });

export const makeStyles = (styles) => {
    const useStyles = tssMakeStyles()(styles);
    return (props = {}) => useStyles(props).classes;
};
